import React from 'react' // eslint-disable-line
import styled, { css } from 'styled-components'
import { MenuItem, BaseMenuItem } from '../../../MenuLayout/MenuLayout.props'
import { Typography, IconMenu } from '../../../Common'
import { Link } from '@sentecacommerce-theme/lib'

type Props = {
  items: MenuItem[]
  desktopMenuClick: () => void
  categoryRef: React.RefObject<any>
  handleMouseleave: (
    allowedRef: React.RefObject<any>,
    callback: () => any
  ) => (event: any) => void
  toggleDesktopNav: (value: boolean) => () => void
}

export const MenuStrip = (props: Props) => {
  const {
    items,
    desktopMenuClick,
    categoryRef,
    handleMouseleave,
    toggleDesktopNav,
  } = props
  const createItem = (item: BaseMenuItem) => {
    if (item.disabled) return null
    if (item.menuClass === 'category') {
      return (
        <Item
          category
          key={item.menuName}
          onClick={desktopMenuClick}
          onMouseEnter={toggleDesktopNav(true)}
          onMouseLeave={handleMouseleave(categoryRef, toggleDesktopNav(false))}
        >
          <IconMenu />
          <span>{item.menuName}</span>
        </Item>
      )
    }

    if (item.menuClass === 'special') {
      return (
        <Item key={item.menuName}>
          <Link href={item.menuUrl as string} passHref>
            <a aria-label={item.menuName}>{item.menuName}</a>
          </Link>
        </Item>
      )
    }

    if (item.menuClass === 'sale') {
      return (
        <Item sale key={item.menuName}>
          <Link href={item.menuUrl as string} passHref>
            <a aria-label={item.menuName}>
              <img
                style={{ width: '65px' }}
                alt="Sale"
                src="https://www.hippoland.net/media/catalog/category/label-action-icon.svg"
              />
            </a>
          </Link>
        </Item>
      )
    }

    return null
  }

  return <>{(items as BaseMenuItem[]).map(createItem)}</>
}

type ItemType = { sale?: boolean; category?: boolean }

const Item = styled(Typography).attrs({
  className: 'mr-4',
  as: 'div',
  variant: 5,
})<ItemType>`
  height: 100%;
  font-size: 1.7rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.5rem 0.7rem;
  border: 0.1rem solid transparent;

  & svg {
    margin-right: 1.2rem;
    margin-top: -0.25rem;
    height: 2.4rem;
    width: 2.4rem;

    & path {
      fill: ${({ theme }) => theme.palette.silverTree};
    }
  }

  & > span,
  a {
    color: ${({ theme }) => theme.palette.silverTree};
  }

  ${(props) =>
    props.category &&
    css`
      padding-bottom: 0.3rem;
      padding-top: 0.3rem;
      padding-left: 0;
    `}

  ${(props) =>
    !props.category &&
    css`
      &:hover {
        border-color: ${({ theme }) => theme.palette.silverTree};
        border-radius: 0.5rem;
      }
    `}

  ${(props) =>
    props.sale &&
    css`
      padding-top: 1rem;
      padding-bottom: 0.3rem;
    `}
`
